// Utility to normalize MinIO URLs to public domain
function normalizeMinioUrl(url) {
  if (!url) return url;
  
  // Replace internal MinIO URLs with public domain
  const minioPublicUrl = 'https://api.mini.tvkparty.org';
  
  // Handle various MinIO URL formats
  // Match: https://minio:9000/tvk-uploads/... or http://minio:9000/tvk-uploads/...
  // Also handle: minio:9000/tvk-uploads/... or just paths starting with /tvk-uploads/
  if (url.includes('minio:9000') || url.includes('minio/') || url.startsWith('http://minio') || url.startsWith('https://minio:') || url.startsWith('/tvk-uploads/')) {
    // Extract the path (everything after /tvk-uploads/)
    const pathMatch = url.match(/\/tvk-uploads\/.+$/);
    if (pathMatch) {
      return `${minioPublicUrl}${pathMatch[0]}`;
    }
    // If it's a full URL, replace the domain and port
    if (url.startsWith('http://') || url.startsWith('https://')) {
      return url.replace(/https?:\/\/[^\/]+(?::\d+)?/, minioPublicUrl);
    }
    // If it's a relative path starting with /tvk-uploads/, prepend the domain
    if (url.startsWith('/tvk-uploads/')) {
      return `${minioPublicUrl}${url}`;
    }
  }
  
  return url;
}

// Utility to generate image URLs for user avatars, falling back to initials if no photoURL is provided.
export function getImageUrl(photoURL, name) {
  if (photoURL) {
    // Normalize MinIO URLs first
    photoURL = normalizeMinioUrl(photoURL);
    
    // If photoURL is already a full URL, return as is
    if (/^https?:\/\//.test(photoURL)) return photoURL;
    
    // Otherwise, treat as relative to API uploads
    const base = import.meta.env.VITE_API_BASE_URL || (window?.location?.hostname === 'localhost' ? 'http://localhost:8788/api' : 'https://api.tvkparty.org/api');
    return `${base}/uploads/${photoURL}`;
  }
  // Fallback: generate a placeholder with initials
  const initials = name ? name.split(' ').map(w => w[0]).join('').toUpperCase().slice(0, 2) : 'U';
  return `https://ui-avatars.com/api/?name=${encodeURIComponent(initials)}&background=0D8ABC&color=fff&size=128`;
}

// Export the normalize function for direct use
export { normalizeMinioUrl };
